import { useState, useEffect } from "react";

export const useRadioChannelData = (slug, initialData = null) => {
  const [channelData, setChannelData] = useState(initialData);
  const [loading, setLoading] = useState(!initialData);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug || initialData) return;

    // Relative URL automatically respects the current environment!
    fetch(`/api/v1/static-pages/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch /api/v1/static-pages/${slug}`);
        return res.json();
      })
      .then((data) => {
        const rawContent = data["static-page"]?.content;
        const parsedContent = typeof rawContent === "string" ? JSON.parse(rawContent) : rawContent;
        setChannelData(parsedContent);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [slug, initialData]);

  return { channelData, loading, error };
};
